import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/breadcrumb';

@Component({
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit {

  	code = Code;
  	items: any[];
    home: any;
	parameters: any[];
	headers: any[];
	styleName: any[];
	styleValue: any[];
	constructor() {

	}

	ngOnInit() {
		
        this.items = [
            {label:'Categories'},
            {label:'Sports'},
            {label:'Football'},
            {label:'Countries'},
            {label:'Spain'},
            {label:'F.C. Barcelona'},
            {label:'Squad'},
            {label:'Lionel Messi', url: 'https://en.wikipedia.org/wiki/Lionel_Messi'}
        ];
        
        this.home = {icon: 'fa ion-ios-home'};
		this.parameters = [
			{name: "model",type: "array",default: "null",des: "菜单项的数组。"},
			{name: "home",type: "MenuItem",default: "null",des: "用于图标的菜单项配置。"},
			{name: "style",type: "string",default: "null",des: "组件的内联样式。"},
			{name: "styleClass",type: "string",default: "null",des: "组件的样式类。"},
		];
		
		this.headers = [
			{name : "名字"},
			{name : "类型"},
			{name : "默认"},
			{name : "描述"}
		];

		this.styleName = [
			{name : "名称"},
			{name : "元素"}
		];

		this.styleValue = [
			{name : "ui-breadcrumb", el: "容器元素"},
			{name : "ui-menuitem", el: "菜单项元素。"},
			{name : "ui-menuitem-text", el: "菜单项的标签。"},
			{name : "ui-breadcrumb-chevron", el: "标志元素。"}
		]
	}

}



// WEBPACK FOOTER //
// ./src/app/view/breadcrumb/breadcrumb.component.ts